import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import Vuesax from 'vuesax';
import 'vuesax/dist/vuesax.css'; // Ensure you import the CSS file

require("@/store/subscriber");

require("./mixin.js");
require("./axios.js");
require('./filters.js')

Vue.config.productionTip = false;

import VueDocPreview from "vue-doc-preview";
Vue.component("VueDocPreview", VueDocPreview);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAm0FfE4ijnd7gx8dQ6KHp2rtOWNs9rYZk",
    // libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  installComponents: true,
});


Vue.use(Vuesax);
store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  new Vue({
    router,
    Vuesax,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
